<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="400" fullscreen>
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title
            >ข้อมูลการแก้ไขของร้าน :
            {{ selected_item.store_name_th }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              $emit('close');
              reject_msg = '';
            "
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          v-if="isLoadingStore == true"
          style="height: calc(100vh - 64px - 81px)"
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100%;
            "
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <div><br />Loading ...</div>
          </div>
        </v-card-text>
        <v-card-text
          v-if="isLoadingStore == false && storeCurrentDetail != null"
          class="pa-0"
        >
          <v-layout
            row
            wrap
            style="height: calc(100vh - 64px - 81px); overflow: auto"
          >
            <v-flex
              xs12
              sm6
              style="border-right: 2px solid #f2f2f2; padding: 24px"
              v-if="selected_item.store_info != null"
            >
              <div class="flex-row my-card">
                <div class="text-title">Store Code : &nbsp;</div>
                <div class="text-content">{{ selected_item.store_code }}</div>
              </div>
              <div class="my-card">
                <div class="text-title">
                  Store name TH:
                  <span
                    :style="
                      selected_item.store_info.store_edit_store_name_th !=
                      storeCurrentDetail.store.store_name_th
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ storeCurrentDetail.store.store_name_th }}</span
                  >
                  <span
                    class="ml-1"
                    style="color: green"
                    v-if="
                      selected_item.store_info.store_edit_store_name_th !=
                      storeCurrentDetail.store.store_name_th
                    "
                    >{{
                      `${selected_item.store_info.store_edit_store_name_th}`
                    }}</span
                  >
                </div>
                <div class="text-title">
                  Store name EN:
                  <span
                    :style="
                      selected_item.store_info.store_edit_store_name_en !=
                      storeCurrentDetail.store.store_name_en
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                    >{{ storeCurrentDetail.store.store_name_en }}</span
                  >
                  <span
                    class="ml-1"
                    style="color: green"
                    v-if="
                      selected_item.store_info.store_edit_store_name_en !=
                      storeCurrentDetail.store.store_name_en
                    "
                    >{{
                      `${selected_item.store_info.store_edit_store_name_en}`
                    }}</span
                  >
                </div>

                <div class="text-title">Store Logo : &nbsp;</div>
                <div class="img-logo-layout1">
                  <a
                    :href="storeCurrentDetail.store.store_image"
                    target="_blank"
                    style="text-decoration: none; color: white"
                  >
                    <img
                      :src="storeCurrentDetail.store.store_image"
                      class="img-logo"
                    />
                    <span class="img-text">Current Logo</span>
                  </a>
                </div>

                <div
                  class="img-logo-layout1"
                  v-if="
                    selected_item.store_info.store_edit_store_image &&
                    selected_item.store_info.store_edit_store_image !=
                      storeCurrentDetail.store.store_image
                  "
                >
                  <a
                    :href="selected_item.store_info.store_edit_store_image"
                    target="_blank"
                    style="text-decoration: none; color: white"
                  >
                    <img
                      :src="selected_item.store_info.store_edit_store_image"
                      class="img-logo"
                    />
                    <span class="img-text">New Logo</span>
                  </a>
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">Store type : &nbsp;</div>
                <li
                  v-for="(info, index) in storeCurrentDetail.store_type"
                  :key="`type1-${index}`"
                  class="text-content"
                  style="text-decoration: line-through; color: red"
                >
                  <span> {{ info.store_type_name_th }}</span>
                  &nbsp; &nbsp;
                </li>
                <li
                  v-for="(info, index) in selected_item.store_info
                    .store_edit_store_type"
                  :key="`type2-${index}`"
                  class="text-content"
                  style="color: green"
                >
                  <span> {{ info.store_type_name_th }}</span>
                  &nbsp; &nbsp;
                </li>
              </div>
              <div class="my-card">
                <div class="text-title">Store Description TH: &nbsp;</div>
                <div
                  class="text-content"
                  :style="
                    selected_item.store_info.store_edit_store_description_th !=
                    storeCurrentDetail.store.store_description_th
                      ? {
                          color: 'red',
                          textDecoration: 'line-through',
                        }
                      : {}
                  "
                >
                  {{ storeCurrentDetail.store.store_description_th }}
                </div>
                <div
                  class="text-content"
                  v-if="
                    selected_item.store_info.store_edit_store_description_th !=
                    storeCurrentDetail.store.store_description_th
                  "
                  style="color: green"
                >
                  {{ selected_item.store_info.store_edit_store_description_th }}
                </div>
                <div class="text-title">Store Description EN: &nbsp;</div>
                <div
                  class="text-content"
                  :style="
                    selected_item.store_info.store_edit_store_description_en !=
                    storeCurrentDetail.store.store_description_en
                      ? {
                          color: 'red',
                          textDecoration: 'line-through',
                        }
                      : {}
                  "
                >
                  {{ storeCurrentDetail.store.store_description_en }}
                </div>
                <div
                  class="text-content"
                  v-if="
                    selected_item.store_info.store_edit_store_description_en !=
                    storeCurrentDetail.store.store_description_en
                  "
                  style="color: green"
                >
                  {{ selected_item.store_info.store_edit_store_description_en }}
                </div>
              </div>

              <div class="my-card">
                <div class="text-title">Store Tel. : &nbsp;</div>
                <div
                  v-for="(info, index) in storeCurrentDetail.store.store_tel"
                  :key="`telold-${index}`"
                  class="text-content"
                  style="color: red; text-decoration: line-through"
                >
                  {{ "+66" + info.tel }} &nbsp;
                </div>
                <div
                  v-for="(info, index) in selected_item.store_info
                    .store_edit_store_tel"
                  :key="`telnew-${index}`"
                  class="text-content"
                  style="color: green"
                >
                  {{ "+66" + info.tel }} &nbsp;
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">Store Email : &nbsp;</div>
                <div
                  class="text-content"
                  :style="
                    selected_item.store_info.store_edit_store_email !=
                    storeCurrentDetail.store.store_email
                      ? {
                          color: 'red',
                          textDecoration: 'line-through',
                        }
                      : {}
                  "
                >
                  {{ storeCurrentDetail.store.store_email }}
                </div>
                <div
                  class="text-content"
                  v-if="
                    selected_item.store_info.store_edit_store_email !=
                    storeCurrentDetail.store.store_email
                  "
                  style="color: green"
                >
                  {{ selected_item.store_info.store_edit_store_email }}
                </div>
              </div>
              <div class="my-card">
                <div class="flex-row">
                  <div class="text-title">Store price rage start : &nbsp;</div>
                  <div
                    class="text-content mr-1"
                    :style="
                      selected_item.store_info
                        .store_edit_store_price_range_start !=
                      storeCurrentDetail.store.store_price_range_start
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ storeCurrentDetail.store.store_price_range_start }}
                  </div>
                  <div
                    class="text-content"
                    v-if="
                      selected_item.store_info
                        .store_edit_store_price_range_start !=
                      storeCurrentDetail.store.store_price_range_start
                    "
                    style="color: green"
                  >
                    {{
                      selected_item.store_info
                        .store_edit_store_price_range_start
                    }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">Store price rage end : &nbsp;</div>
                  <div
                    class="text-content mr-1"
                    :style="
                      selected_item.store_info
                        .store_edit_store_price_range_end !=
                      storeCurrentDetail.store.store_price_range_end
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ storeCurrentDetail.store.store_price_range_end }}
                  </div>
                  <div
                    class="text-content"
                    v-if="
                      selected_item.store_info
                        .store_edit_store_price_range_end !=
                      storeCurrentDetail.store.store_price_range_end
                    "
                    style="color: green"
                  >
                    {{
                      selected_item.store_info.store_edit_store_price_range_end
                    }}
                  </div>
                </div>
              </div>
            </v-flex>
            <v-flex
              xs12
              sm6
              style="border-right: 2px solid #f2f2f2; padding: 24px"
              v-if="selected_item.store_info != null"
            >
              <div class="my-card" v-if="selected_item.store_info != null">
                <div class="text-title">Store Address TH : &nbsp;</div>
                <div
                  class="text-content"
                  :style="
                    selected_item.store_info.store_edit_store_address_th !=
                    storeCurrentDetail.store.store_address_th
                      ? {
                          color: 'red',
                          textDecoration: 'line-through',
                        }
                      : {}
                  "
                >
                  {{ storeCurrentDetail.store.store_address_th }}
                </div>
                <div
                  class="text-content"
                  v-if="
                    selected_item.store_info.store_edit_store_address_th !=
                    storeCurrentDetail.store.store_address_th
                  "
                  style="color: green"
                >
                  {{ selected_item.store_info.store_edit_store_address_th }}
                </div>
              </div>
              <div class="my-card" v-if="selected_item.store_info != null">
                <div class="text-title">Store Address EN : &nbsp;</div>
                <div
                  class="text-content"
                  :style="
                    selected_item.store_info.store_edit_store_address_en !=
                    storeCurrentDetail.store.store_address_en
                      ? {
                          color: 'red',
                          textDecoration: 'line-through',
                        }
                      : {}
                  "
                >
                  {{ storeCurrentDetail.store.store_address_en }}
                </div>
                <div
                  class="text-content"
                  v-if="
                    selected_item.store_info.store_edit_store_address_en !=
                    storeCurrentDetail.store.store_address_en
                  "
                  style="color: green"
                >
                  {{ selected_item.store_info.store_edit_store_address_en }}
                </div>
              </div>
              <div class="my-card" v-if="selected_item.store_info != null">
                <div class="flex-row">
                  <div class="text-title">Store Province : &nbsp;</div>
                  <div
                    class="text-content mr-1"
                    :style="
                      selected_item.store_info.store_edit_store_province !=
                      storeCurrentDetail.store_province.province_id
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ storeCurrentDetail.store_province.province_name_th }}
                  </div>
                  <div
                    class="text-content"
                    v-if="
                      selected_item.store_info.store_edit_store_province !=
                      storeCurrentDetail.store_province.province_id
                    "
                    style="color: green"
                  >
                    {{
                      storeProvinceName(
                        selected_item.store_info.store_edit_store_province
                      ).province_name_th
                    }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">Store District : &nbsp;</div>
                  <div
                    class="text-content mr-1"
                    :style="
                      selected_item.store_info.store_edit_store_district !=
                      storeCurrentDetail.store_district.district_id
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ storeCurrentDetail.store_district.district_name_th }}
                  </div>
                  <div
                    class="text-content"
                    v-if="
                      selected_item.store_info.store_edit_store_district !=
                      storeCurrentDetail.store_district.district_id
                    "
                    style="color: green"
                  >
                    {{
                      storeDistrictName(
                        selected_item.store_info.store_edit_store_district
                      ).district_name_th
                    }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">Store Sub District : &nbsp;</div>
                  <div
                    class="text-content mr-1"
                    :style="
                      selected_item.store_info.store_edit_store_sub_district !=
                      storeCurrentDetail.store_sub_district.sub_district_id
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{
                      storeCurrentDetail.store_sub_district.sub_district_name_th
                    }}
                  </div>
                  <div
                    class="text-content"
                    v-if="
                      selected_item.store_info.store_edit_store_sub_district !=
                      storeCurrentDetail.store_sub_district.sub_district_id
                    "
                    style="color: green"
                  >
                    {{
                      storeSubDistrictName(
                        selected_item.store_info.store_edit_store_sub_district
                      ).sub_district_name_th
                    }}
                  </div>
                </div>
                <div class="flex-row">
                  <div class="text-title">Store Zipcode : &nbsp;</div>
                  <div
                    class="text-content mr-1"
                    :style="
                      selected_item.store_info.store_edit_store_zipcode !=
                      storeCurrentDetail.store_zipcode.zipcode_id
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ storeCurrentDetail.store_zipcode.zipcode_code }}
                  </div>
                  <div
                    class="text-content"
                    v-if="
                      selected_item.store_info.store_edit_store_zipcode !=
                      storeCurrentDetail.store_zipcode.zipcode_id
                    "
                    style="color: green"
                  >
                    {{
                      storeZipcodeList(
                        selected_item.store_info.store_edit_store_zipcode
                      ).zipcode_code
                    }}
                  </div>
                </div>
              </div>
              <div class="my-card" v-if="selected_item.store_info != null">
                <div class="text-title">Store Note : &nbsp;</div>
                <div
                  class="text-content"
                  :style="
                    selected_item.store_info.store_edit_store_note !=
                    storeCurrentDetail.store.store_note
                      ? {
                          color: 'red',
                          textDecoration: 'line-through',
                        }
                      : {}
                  "
                >
                  {{ storeCurrentDetail.store.store_note }}
                </div>
                <div
                  class="text-content"
                  v-if="
                    selected_item.store_info.store_edit_store_note !=
                    storeCurrentDetail.store.store_note
                  "
                  style="color: green"
                >
                  {{ selected_item.store_info.store_edit_store_note }}
                </div>
              </div>
              <div class="my-card">
                <div class="text-title" style="text-decoration: underline">
                  Current Location &nbsp;
                </div>

                <div class="text-content">
                  <span style="color: grey"> Latitude: </span>
                  <span
                    :style="
                      selected_item.store_latlng != null &&
                      selected_item.store_latlng.store_edit_store_lat !=
                        storeCurrentDetail.store.store_lat
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ `${storeCurrentDetail.store.store_lat}` }}</span
                  >
                  <span
                    v-if="
                      selected_item.store_latlng != null &&
                      selected_item.store_latlng.store_edit_store_lat !=
                        storeCurrentDetail.store.store_lat
                    "
                    style="color: green"
                  >
                    {{ selected_item.store_latlng.store_edit_store_lat }}</span
                  >
                </div>
                <div class="text-content">
                  <span style="color: grey"> Longitude: </span>
                  <span
                    :style="
                      selected_item.store_latlng != null &&
                      selected_item.store_latlng.store_edit_store_long !=
                        storeCurrentDetail.store.store_long
                        ? {
                            color: 'red',
                            textDecoration: 'line-through',
                          }
                        : {}
                    "
                  >
                    {{ `${storeCurrentDetail.store.store_long}` }}</span
                  >
                  <span
                    v-if="
                      selected_item.store_latlng != null &&
                      selected_item.store_latlng.store_edit_store_long !=
                        storeCurrentDetail.store.store_long
                    "
                    style="color: green"
                  >
                    {{ selected_item.store_latlng.store_edit_store_long }}</span
                  >
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">New Location:</div>
                <div
                  class="text-content"
                  v-if="
                    (selected_item.store_latlng != null &&
                      selected_item.store_latlng.store_edit_store_long !=
                        storeCurrentDetail.store.store_long) ||
                    selected_item.store_latlng.store_edit_store_lat !=
                      storeCurrentDetail.store.store_lat
                  "
                >
                  <GoogleMap
                    style="margin-bottom: 10px"
                    v-if="
                      selected_item.store_latlng != null &&
                      selected_item.store_latlng.store_edit_store_lat &&
                      selected_item.store_latlng.store_edit_store_long
                    "
                    :latitude="
                      parseFloat(
                        selected_item.store_latlng.store_edit_store_lat
                      )
                    "
                    :longitude="
                      parseFloat(
                        selected_item.store_latlng.store_edit_store_long
                      )
                    "
                    :height="350"
                    :zoom="15"
                    :mapType="'latandlong'"
                    :draggable="false"
                  ></GoogleMap>
                </div>
                <div class="text-content" v-else>ไม่มีการแก้หมุดร้านค้า</div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions style="border-top: 2px solid #f2f2f2">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            style="border-radius: 15px; height: 40px"
            color="grey darken-1"
            class="white--text"
            :loading="deleting_store"
            @click="deleteApproveStore()"
            >Delete</v-btn
          >
          <v-btn
            depressed
            color="red"
            class="white--text"
            :loading="rejecting_store"
            @click="rejectDialog = true"
            style="margin-left: 8px; border-radius: 15px; height: 40px"
            >reject</v-btn
          >
          <v-btn
            depressed
            color="green darken-1"
            class="white--text"
            :loading="approving_store"
            @click="approveStore()"
            style="border-radius: 15px; height: 40px"
            >Approve</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rejectDialog" width="400px">
      <v-card>
        <div class="pl-3 pr-3 pt-3">
          <h2>Do you want to reject ?</h2>
        </div>
        <v-card-text class="pt-0">
          <v-text-field
            label="Message"
            v-model="reject_msg"
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              rejectDialog = false;
              reject_msg = '';
            "
          >
            <v-icon medium color="error">close</v-icon>
          </v-btn>
          <v-btn icon @click="rejectStore()">
            <v-icon medium color="success">check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    dialog: {
      type: Boolean,
      default() {
        return false;
      },
    },
    selected_item: {
      type: Object,
      default() {
        return { msg: null };
      },
    },
  },
  data() {
    return {
      rejectDialog: false,
      reject_msg: "",
      store_detail: {},
      isLoadingStore: false,
      rejecting_store: false,
      approving_store: false,
      deleting_store: false,
      storeCurrentDetail: null,
      districtList: [],
      subDistrictList: [],
      zipcodeList: [],
    };
  },
  watch: {
    async dialog() {
      if (this.dialog === true) {
        this.isLoadingStore = true;
        this.districtList = await this.fetchDistrictList(
          this.selected_item.store_info.store_edit_store_province
        );
        this.subDistrictList = await this.fetchSubDistrictList(
          this.selected_item.store_info.store_edit_store_district
        );
        this.zipcodeList = await this.fetchZipcodeList(
          this.selected_item.store_info.store_edit_store_district
        );
        let config = {
          province: this.selected_item.store_province,
          storeId: this.selected_item.store_id,
        };
        this.storeCurrentDetail = await this.fetchStoreDetail(config);

        this.isLoadingStore = false;
      }
    },
  },
  created() {},
  computed: {
    ...mapState({
      provinceList: (state) => state.fetchProvinceBack.provinceData,
    }),
  },
  methods: {
    ...mapActions({
      fetchStoreDetail: "fetchStoreBack/manualGetStoreDetailByProvinceName",
      fetchDistrictList: "fetchProvinceBack/getDistrictCore",
      fetchSubDistrictList: "fetchProvinceBack/getSubDistrictCore",
      fetchZipcodeList: "fetchProvinceBack/getZipCodeCore",
    }),
    storeProvinceName(Id) {
      return (
        this.provinceList.find((val) => val.province_id === Id) || {
          province_name_th: "",
        }
      );
    },
    storeDistrictName(Id) {
      return (
        this.districtList.find((val) => val.district_id === Id) || {
          district_name_th: "",
        }
      );
    },
    storeSubDistrictName(Id) {
      return (
        this.subDistrictList.find((val) => val.sub_district_id === Id) || {
          sub_district_name_th: "",
        }
      );
    },
    storeZipcodeList(Id) {
      return (
        this.zipcodeList.find((val) => val.zipcode_id === Id) || {
          zipcode_code: "",
        }
      );
    },
    async deleteApproveStore() {
      this.deleting_store = true;
      let check = await this.$store.dispatch(
        "fetchStoreApproveBack/deleteStoreEdit",
        this.selected_item.store_edit_id
      );
      this.deleting_store = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
    async approveStore() {
      this.approving_store = true;
      let check = await this.$store.dispatch(
        "fetchStoreApproveBack/approveEditStoreApprove",
        this.selected_item.store_edit_id
      );
      this.approving_store = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
    async rejectStore() {
      this.rejectDialog = false;
      this.rejecting_store = true;
      let data = {
        config_path: {
          province: this.selected_item.store_province,
          store_id: this.selected_item.store_edit_id,
        },
        form: {
          msg: this.reject_msg,
        },
      };
      let check = await this.$store.dispatch(
        "fetchStoreApproveBack/rejectEditStoreApprove",
        data
      );
      this.rejecting_store = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
  },
};
</script>
<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.text-title {
  font-size: 14px;
  font-weight: 500;
  color: #666;
}
.text-content {
  font-size: 16px;
  font-weight: 500;
}
.my-card {
  border: 2px solid rgb(242, 242, 242);
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 10px;
}
.img-logo-layout1 {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  height: 120px;
  width: 120px;
  min-width: 120px;
  position: relative;
  text-align: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
  background: white;
  -webkit-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}
.img-logo {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  object-fit: cover;
}
.img-text {
  background-image: linear-gradient(to bottom, transparent, black);
  width: 100%;
  line-height: 30px;
  border-radius: 0 0 20px 20px;
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}
</style>
